import { IconProps } from "./IconProps";

function ListIcon({
	width = "24",
	height = "24",
	color = "#223234",
	viewBox = "0 0 24 24",
}: IconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox={viewBox}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 2C0 0.89543 0.89543 0 2 0C3.10457 0 4 0.89543 4 2C4 3.10457 3.10457 4 2 4C0.89543 4 0 3.10457 0 2ZM6 2C6 1.44772 6.44772 1 7 1H19C19.5523 1 20 1.44772 20 2C20 2.55229 19.5523 3 19 3L7 3C6.44772 3 6 2.55228 6 2ZM0 8C0 6.89543 0.89543 6 2 6C3.10457 6 4 6.89543 4 8C4 9.10457 3.10457 10 2 10C0.89543 10 0 9.10457 0 8ZM6 8C6 7.44772 6.44772 7 7 7L19 7C19.5523 7 20 7.44772 20 8C20 8.55229 19.5523 9 19 9L7 9C6.44772 9 6 8.55228 6 8ZM0 14C0 12.8954 0.89543 12 2 12C3.10457 12 4 12.8954 4 14C4 15.1046 3.10457 16 2 16C0.89543 16 0 15.1046 0 14ZM6 14C6 13.4477 6.44772 13 7 13L19 13C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15L7 15C6.44772 15 6 14.5523 6 14Z"
				fill={color}
			/>
		</svg>
	);
}
export default ListIcon;
